import { render, staticRenderFns } from "./SugSelect.vue?vue&type=template&id=f5cb6252&scoped=true&"
import script from "./SugSelect.vue?vue&type=script&lang=js&"
export * from "./SugSelect.vue?vue&type=script&lang=js&"
import style0 from "./SugSelect.vue?vue&type=style&index=0&id=f5cb6252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cb6252",
  null
  
)

export default component.exports